module.exports = __webpack_public_path__ + "img/careem_box.004d3405.png";